/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertCMASubjectPropertyByMlsIdResponseDto
 */
export interface UpsertCMASubjectPropertyByMlsIdResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertCMASubjectPropertyByMlsIdResponseDto
     */
    id?: string;
}

/**
 * Check if a given object implements the UpsertCMASubjectPropertyByMlsIdResponseDto interface.
 */
export function instanceOfUpsertCMASubjectPropertyByMlsIdResponseDto(value: object): value is UpsertCMASubjectPropertyByMlsIdResponseDto {
    return true;
}

export function UpsertCMASubjectPropertyByMlsIdResponseDtoFromJSON(json: any): UpsertCMASubjectPropertyByMlsIdResponseDto {
    return UpsertCMASubjectPropertyByMlsIdResponseDtoFromJSONTyped(json, false);
}

export function UpsertCMASubjectPropertyByMlsIdResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertCMASubjectPropertyByMlsIdResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function UpsertCMASubjectPropertyByMlsIdResponseDtoToJSON(json: any): UpsertCMASubjectPropertyByMlsIdResponseDto {
    return UpsertCMASubjectPropertyByMlsIdResponseDtoToJSONTyped(json, false);
}

export function UpsertCMASubjectPropertyByMlsIdResponseDtoToJSONTyped(value?: UpsertCMASubjectPropertyByMlsIdResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

